// Load Styles
import '../../../scss/page/roojai/contact.scss';
import {utility, toggleScrollToSection} from '../../utility.js';

// Your app code
function initGoogleMap( element, latlang, params) {
  var _map = new google.maps.Map( element,  params );

  var marker = new google.maps.Marker( {
    position: latlang,
    map: _map,
  } );
}

const element = document.getElementById( "gmap" );

const latlang = new google.maps.LatLng( -6.2948497, 106.8155583 );

const params = {
  center: latlang,
  zoom: 15,
  disableDefaultUI: true,
  mapTypeId: google.maps.MapTypeId.ROADMAP,
}

initGoogleMap( element, latlang, params );

utility();
